import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import FFLDetail from '@/explore/ffl-detail/FFLDetail';
import Licensee from '@/model/licensee.mjs';
import LicenseNumberResult from '../result-lists/LicenseNumberResult';
import { useSearchParams } from 'react-router-dom';
import { ShowTransferModel } from '@/queue/elements/QueueGrid';

interface Props {
  data?: Licensee;
  id?: string;
  isOpen: boolean;
  onClose: () => void;
  cognitoGroup: boolean;
  isSuperAdmin: boolean;
}

export default function FFLDetailModal({
  data,
  id,
  isOpen,
  onClose,
  cognitoGroup,
  isSuperAdmin
}: Props) {
  function formatId() {
    const first1 = id?.substring(0, 1) || '';
    let second2 = id?.substring(2, 4) || '';
    const last5 = id?.substring(id.length - 5) || '';
    if (id && id.length == 8) second2 = id?.substring(1, 3) || '';
    return { first1, second2, last5 };
  }
  const [query, setQuery] = useSearchParams();
  const {
    isOpen: isTransferModalOpen,
    onClose: onCloseTransferModal,
    onOpen: onOpenTransferModal
  } = useDisclosure();
  const showTransferId = query.get('transfer_id');

  const onCloseTransferModalHandler = () => {
    onCloseTransferModal();
    query.delete('transfer_id');
    setQuery(query);
  };

  useEffect(() => {
    if (window) {
      const transferId = query.get('transfer_id');
      if (transferId) onOpenTransferModal();
    }
  }, [query]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'full'}>
      <ModalOverlay />
      <ModalContent className={'FFLDetailModal'}>
        <ModalHeader>FFL Detail</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {data ? (
            <>
              {isTransferModalOpen && (
                <ShowTransferModel
                  isOpen={isTransferModalOpen}
                  onClose={onCloseTransferModalHandler}
                  transfer={{ id: showTransferId as string }}
                  reFetchData={() => {}}
                  isSuperAdmin={isSuperAdmin}
                  isStoreAdmin={false}
                  cognitoGroup={false}
                />
              )}
              <FFLDetail
                data={data}
                cognitoGroup={cognitoGroup}
                isSuperAdmin={isSuperAdmin}
              />
            </>
          ) : (
            <LicenseNumberResult
              first1={formatId().first1}
              second2={formatId().second2}
              last5={formatId().last5}
              cognitoGroup={cognitoGroup}
              isSuperAdmin={isSuperAdmin}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
